import { Box } from '@mui/material';

import { ProjectCard } from 'routes/Projects/ProjectCard';
import { useRecoilValue } from 'recoil';
import { projectState } from 'state';

export default function ProjectSelector() {
  const { projects } = useRecoilValue(projectState);

  return (
    <Box display="flex" flexDirection="row" flexWrap="wrap" mt={2}>
      {projects.map(project => (
        <ProjectCard project={project} key={`project-card-key-${project.id}`} />
      ))}
    </Box>
  );
}
